import { useMemo } from "react";
import type { WorkbookSheet } from "../../../shared/account-finance/finance-workbook-contract";
import { financeObservedAt } from "./finance-presentation";
import { financeSheetRecords } from "./finance-records";
import { useFinanceRecordsWorkspace } from "./useFinanceRecordsWorkspace";
import { FinanceRecordsTable } from "./FinanceRecordsTable";
import { workbookSheetLabel } from "./finance-workbook-presentation";

export function FinanceWorkbookSheet({ sheet, search, setPage }: {
  sheet: WorkbookSheet; search: string; setSearch: (value: string) => void; setPage: (page: number) => void;
}) {
  const records = useMemo(() => financeSheetRecords(sheet), [sheet]);
  const title = workbookSheetLabel(sheet.id, sheet.id);
  const model = useFinanceRecordsWorkspace(records, { title, company: sheet.company, date: sheet.date,
    observedAt: sheet.observedAt, notes: [sheet.note, sheet.hasMore ? "Kaynak kapsamı eksik; yalnız yüklenmiş kayıtlar dışa aktarıldı." : "Yüklenmiş kaynağın filtrelenen kayıtları."],
  }, search);
  return <section className="workbook-sheet" aria-label="Finans kaynak kayıtları">
    <p className="workbook-scope-note">Son okuma {financeObservedAt(sheet.observedAt)}{sheet.hasMore ? " · Kaynağın tamamı yüklenmedi; bu listeyi genel toplam olarak kullanmayın." : ""}</p>
    {sheet.kind === "schedule" && <p className="workbook-scope-note">Plan / tahmin kayıtlarıdır. Kesinleşmiş veya gerçekleşmiş ödeme olarak kabul edilmez.</p>}
    <FinanceRecordsTable model={model} caption={title} />
    {sheet.kind === "ledger" && <div className="workbook-sheet-footer"><span>Muhasebe kaynağı · sayfa {sheet.page}. Filtreler yüklenen kaynak sayfasında uygulanır.</span><div>
      <button type="button" className="finance-button" disabled={sheet.page <= 1} onClick={() => setPage(sheet.page - 1)}>Önceki kaynak sayfası</button>
      <button type="button" className="finance-button" disabled={!sheet.hasMore} onClick={() => setPage(sheet.page + 1)}>Sonraki kaynak sayfası</button>
    </div></div>}
    <details className="workbook-source-note"><summary>Veri kapsamı ve hesaplama</summary><p>{sheet.note}</p></details>
  </section>;
}
